import { TemplateStatus } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';

export const templateStatusOptions = {
  [TemplateStatus.Draft]: {
    label: 'Draft',
    value: TemplateStatus.Draft,
    raw: TemplateStatus.Draft,
    color: 'blue',
  },
  [TemplateStatus.Archived]: {
    label: 'Archived',
    value: TemplateStatus.Archived,
    raw: TemplateStatus.Archived,
    color: 'gray',
  },
  [TemplateStatus.Published]: {
    label: 'Published',
    value: TemplateStatus.Published,
    raw: TemplateStatus.Published,
    color: 'green',
  },
};

interface Props extends ChakraV3.TagProps {
  status: TemplateStatus;
}

export const TemplateStatusTag = (props: Props) => {
  const { status, ...rest } = props;

  const { label, color } = templateStatusOptions[status];

  return (
    <ChakraV3.Tag size='sm' colorPalette={color} {...rest}>
      {label}
    </ChakraV3.Tag>
  );
};
